<template>
  <div class="wrapper">
    <!-- 标题区域 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-s-shop title-icon"></i>
          {{ $route.meta.name }}
        </h2>
        <div class="header-stats">
          <div class="stat-item">
            <span class="stat-label">总记录数</span>
            <span class="stat-value">{{ total }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-search"></i>
        <span>筛选条件</span>
      </div>
      <div class="header-search">
        <el-form ref="form" inline :model="searchData" label-width="100px">
          <el-form-item label="门店名称">
            <el-input
              v-model="searchData.storeName"
              size="small"
              placeholder="请输入"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="门店类型">
            <el-select
              v-model="searchData.storeType"
              placeholder="请选择"
              size="small"
              clearable
              style="width: 200px"
            >
              <el-option
                v-for="item in dict_store_type"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="负责人手机号">
            <el-input
              v-model="searchData.legalMobile"
              size="small"
              placeholder="请输入"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
              style="width: 300px"
              v-model="searchData.timeSlot"
              size="small"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="门店BD">
            <SelectAdmin v-model="searchData.businessUserId" style="width: 200px;" />
          </el-form-item>
          <el-form-item label="结算方式">
            <el-select
              v-model="searchData.settleType"
              placeholder="请选择"
              size="small"
              clearable
              style="width: 200px"
            >
              <el-option
                v-for="item in paymentMethod"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" " label-width="50px">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="getList"
              class="search-btn"
              >搜索</el-button
            >
            <el-button
              type="info"
              size="small"
              icon="el-icon-refresh"
              @click="reset"
              class="reset-btn"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-s-grid"></i>
        <span>门店列表</span>
        <div class="header-actions">
          <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.store_list_add)"
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="showAddOrEdit = true; rowId = null"
            class="add-btn"
            >新增</el-button
          >
          <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.store_list_export)"
            size="small"
            icon="el-icon-download"
            type="primary"
            @click="exportExcel"
            class="export-btn"
            >导出</el-button
          >
        </div>
      </div>
      <tp-table
        :isNeedSerialNumber="true"
        :tableData="list"
        :columns="columns"
        :totalNum="total"
        :current-page.sync="currentPage"
        :pageSize.sync="pageSize"
      />
    </el-card>

    <!-- 物料弹窗 -->
    <el-dialog
      :title="`门店名称：${storeName}`"
      :visible.sync="dialogVisibleMaterial"
      width="700px"
      class="material-dialog"
    >
      <div class="dialog-content">
        <div class="section-title">
          <i class="el-icon-picture"></i>
          <span>h5物料</span>
        </div>
        <div class="code-img">
          <el-image style="width: 200px" fit="fill" :src="materialUrl" class="material-image"></el-image>
          <el-button
            type="primary"
            size="small"
            @click="downloadMaterial"
            class="download-btn"
            >下载</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 支付宝物料弹窗 -->
    <el-dialog
      :title="`门店名称：${storeName}`"
      :visible.sync="dialogVisibleAlipayMaterial"
      width="700px"
      class="material-dialog"
    >
      <div class="dialog-content">
        <div class="section-title">
          <i class="el-icon-picture"></i>
          <span>支付宝物料</span>
        </div>
        <div class="code-img">
          <el-image
            style="width: 200px"
            fit="fill"
            :src="alipayMaterialUrl"
            class="material-image"
          ></el-image>
          <el-button
            type="primary"
            size="small"
            @click="downloadAlipayMaterialImage"
            class="download-btn"
            >下载</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-drawer
      title="门店详情"
      :visible.sync="show_detail"
      direction="rtl"
      size="50%"
      class="store-detail-drawer"
    >
      <div class="store-detail">
        <el-descriptions direction="vertical" :column="3" border class="detail-descriptions">
          <el-descriptions-item label="门店名称">{{ detail.storeName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="门店编号">{{ detail.storeCode || '-' }}</el-descriptions-item>
          <el-descriptions-item label="门店地址">{{ detail.addressDetail || '-' }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="detail.status ? 'success' : 'danger'" size="small">{{ detail.status ? "启用" : "禁用" }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="负责人">{{ detail.legalName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="负责人手机号">{{ detail.legalMobile || '-' }}</el-descriptions-item>
          <el-descriptions-item label="门店BD">{{ businessUserName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="监管服务费">{{ detail.lockAmount || '-' }}</el-descriptions-item>
          <el-descriptions-item label="门店标签">
            <el-tag
              style="margin-right: 5px"
              type="danger"
              size="mini"
              v-for="(item, i) in detail.storeTagList"
              :key="i"
              >{{ item }}</el-tag
            >
            <span v-if="detail.storeTagList && detail.storeTagList.length == 0">无</span>
          </el-descriptions-item>
          <el-descriptions-item label="开户行">{{ detail.bankName || "未设置" }}</el-descriptions-item>
          <el-descriptions-item label="银行卡号">{{ detail.bankCardNo || "未设置" }}</el-descriptions-item>
          <el-descriptions-item label=""> </el-descriptions-item>
          <el-descriptions-item label="门店结算方式">
            <el-tag :type="detail.settleType === 1 ? 'info' : 'success'" size="small">
              {{ detail.settleType === 1 ? "线下打款" : "支付宝自动结算" }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="收款账户信息">{{ countInfo || '-' }}</el-descriptions-item>
        </el-descriptions>
        <el-tabs v-model="activeName" class="detail-tabs">
          <el-tab-pane label="营业执照" name="first">
            <div class="image-container">
              <el-image
                style="width: 400px; height: 300px"
                :src="detail.licenseImageUrl"
                :preview-src-list="[detail.licenseImageUrl]"
                fit="cover"
                class="detail-image"
              ></el-image>
            </div>
          </el-tab-pane>
          <el-tab-pane label="门头照片" name="second">
            <div class="image-container">
              <el-image
                style="width: 300px; height: 200px; margin-right: 10px"
                v-for="(item, i) in detail.facadeImageUrlList"
                :key="i"
                :src="item"
                :preview-src-list="[item]"
                fit="cover"
                class="detail-image"
              ></el-image>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>

    <!-- 新增&编辑 -->
    <AddOrEdit
        v-if="showAddOrEdit"
        :rowId="rowId"
        :showAddOrEdit="showAddOrEdit"
        @closeDialog="closeDialogFun"
    />

    <ComboSetting
      :visible.sync="comboSettingProps.visible"
      :id="comboSettingProps.id"
      @refreshList="getList"
    />

    <StoreGrade
      :visible.sync="storeGradeProps.visible"
      :id="storeGradeProps.id"
      :grade="storeGradeProps.grade"
      @refreshList="getList"
    />
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import {
  exportAPI,
  getListAPI,
  deleteStoreAPI,
  changeStatusAPI,
  getStoreMaterialAPI,
  getStoreAlipayMaterialAPI,
  downloadFile,
  getStoreDetailAPI,
  changeEnableLoginAPI,
} from "./api";
import SelectAdmin from "@/views/components/select-admin.vue";
import ComboSetting from "@/views/store/combo/combo-setting.vue";
import StoreGrade from "./store-grade.vue";
import { dict_store_type } from "@/enum/dict/index.js";
import AddOrEdit from "./add-edit.vue";

const columns = [
  {
    label: "门店名称",
    prop: "storeName",
    minWidth: "220",
    customRender(h, row) {
      return (
        <div class="store-name-cell">
          <span class="store-name">{row["storeName"] || '-'}</span>
          <div class="store-tags">
            {row["storeTagList"] && row["storeTagList"].map((item) => {
              return (
                <el-tag type="danger" size="mini" class="store-tag">
                  {item}
                </el-tag>
              );
            })}
          </div>
        </div>
      );
    },
  },
  {
    label: "门店编号",
    prop: "storeCode",
    minWidth: "140",
    customRender(h, row) {
      return <p class="table-cell-text">{row["storeCode"] || '-'}</p>;
    },
  },
  {
    label: "门店等级",
    prop: "storeGrade",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["storeGrade"] ? `${row["storeGrade"]}级` : "-"}</p>;
    },
  },
  {
    label: "门店类型",
    prop: "storeType",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["storeTypeName"] || '-'}</p>;
    },
  },
  {
    label: "门店地址",
    prop: "address",
    minWidth: "200",
    customRender(h, row) {
      return <p class="table-cell-text">{row["address"] || '-'}</p>;
    },
  },
  {
    label: "负责人",
    prop: "legalName",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["legalName"] || '-'}</p>;
    },
  },
  {
    label: "负责人手机号",
    prop: "legalMobile",
    minWidth: "140",
    customRender(h, row) {
      return <p class="table-cell-text">{row["legalMobile"] || '-'}</p>;
    },
  },
  {
    label: "结算方式",
    prop: "settleTypeName",
    minWidth: "130",
    customRender(h, row) {
      return <p class="table-cell-text">{row["settleTypeName"] || '-'}</p>;
    },
  },
  {
    label: "监管服务费",
    prop: "lockAmount",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text amount-value">{row["lockAmount"] || '-'}</p>;
    },
  },
  {
    label: "返点方案数",
    prop: "rewardComboNum",
    minWidth: "100"
  },
  {
    label: "创建时间",
    prop: "createTime",
    minWidth: "180",
    customRender(h, row) {
      return <p class="table-cell-text">{row["createTime"] || '-'}</p>;
    },
  },
  {
    label: "状态",
    prop: "status",
    minWidth: "120",
    customRender(h, row) {
      return (
        <div>
          <el-switch
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_status)}
            class="switch"
            onChange={() => this.changeStatus(row)}
            v-model={row["status"]}
            active-value={true}
            inactive-value={false}
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </div>
      );
    },
  },
  {
    label: "后台登录",
    prop: "status",
    minWidth: "120",
    customRender(h, row) {
      return (
        <div>
          <el-switch
            class="switch"
            onChange={() => this.changeEnableLogin(row)}
            v-model={row["enableLogin"]}
            active-value={true}
            inactive-value={false}
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </div>
      );
    },
  },
  {
    label: "门店BD",
    prop: "businessUserName",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["businessUserName"] || '-'}</p>;
    },
  },
  {
    label: "操作",
    minWidth: "280",
    fixed: "right",
    customRender(h, row) {
      return (
        <div class="action-links">
          <el-link
            disabled={ !this.isShowBtn(this.AUTH_BTN.store_list_detail) }
            underline={false}
            type="primary"
            onClick={() => this.handleDetail(row)}
            class="action-link"
          >
            详情
          </el-link>

          <el-link
            disabled={ row["status"] || !this.isShowBtn(this.AUTH_BTN.store_list_edit) }
            underline={false}
            type="primary"
            onClick={() => {
              this.showAddOrEdit = true;
              this.rowId = row['id'];
            }}
            class="action-link"
          >
            编辑
          </el-link>

          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_material)}
            underline={false}
            type="primary"
            onClick={() => this.showMaterialImage(row)}
            class="action-link"
          >
            h5物料
          </el-link>

          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_alipay_material)}
            underline={false}
            type="primary"
            onClick={() => this.showAlipayMaterialImage(row)}
            class="action-link"
          >
            支付宝物料
          </el-link>

          <el-link
            underline={false}
            type="primary"
            onClick={() => this.showStoreGradeDialog(row)}
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_grade_config)}
            class="action-link"
          >
            等级配置
          </el-link>

          <el-link
            underline={false}
            type="primary"
            onClick={() => this.showComboSettingDialog(row)}
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_combo_config)}
            class="action-link"
          >
            方案配置
          </el-link>
        </div>
      );
    },
  },
];

export default {
  name: "StoreList",
  mixins: [authBtnMixin],
  components: { SelectAdmin, AddOrEdit, ComboSetting, StoreGrade },
  data() {
    return {
      dialogVisibleMaterial: false,
      dialogVisibleAlipayMaterial: false,
      dialogVisible: false,
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        storeName: "",
        storeType: "",
        legalMobile: "",
        timeSlot: [],
        businessUserId: "",
        settleType: "",
        enableRewardCombo: "",
      },
      storeName: "",
      url: "",
      qrcodeUrl: "",
      materialUrl: "",
      alipayMaterialUrl: "",
      show_detail: false,
      detail: {},
      businessUserName: "",
      activeName: "first",
      dict_store_type,
      paymentMethod: [
        {
          label: "线下打款",
          value: 1,
        },
        // {
        //   label: "支付宝自动结算",
        //   value: 2,
        // },
      ],
      rowId: null,
      showAddOrEdit: false,
      comboSettingProps: {
        visible: false,
        id: null,
      },
      storeGradeProps: {
        visible: false,
        id: null,
        grade: null,
      },
    };
  },

  provide() {
    return {
      context: this,
    };
  },

  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },

  computed: {
    countInfo() {
      if (this.detail.settleType === 1) {
        return "";
      } else {
        return (
          "姓名：" +
          (this.detail.payeeIdName || "-") +
          "        支付宝账号：" +
          (this.detail.payeeAlipayAccount || "-")
        );
      }
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    showStoreGradeDialog(row) {
      this.storeGradeProps.visible = true;
      this.storeGradeProps.id = row.id;
      this.storeGradeProps.grade = row.storeGrade;
    },

    showComboSettingDialog(row) {
      this.comboSettingProps.visible = true;
      this.comboSettingProps.id = row.id;
    },

    // 详情
    async handleDetail({ id, businessUserName }) {
      this.detail = await getStoreDetailAPI(id);
      this.businessUserName = businessUserName;
      this.show_detail = true;
    },

    async getList() {
      const {
        storeName,
        storeType,
        legalMobile,
        timeSlot,
        businessUserId,
        settleType,
        enableRewardCombo,
      } = this.searchData;
      let params = {
        storeName,
        storeType,
        legalMobile,
        businessUserId,
        settleType,
        enableRewardCombo,
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      if (timeSlot && timeSlot.length > 0) {
        params.leftCreateDate = timeSlot[0];
        params.rightCreateDate = timeSlot[1];
      }
      const res = await getListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },

    // 导出
    exportExcel() {
      const {
        storeName,
        storeType,
        legalMobile,
        timeSlot,
        businessUserId,
        settleType,
        enableRewardCombo,
      } = this.searchData;
      let params = {
        storeName,
        storeType,
        legalMobile,
        businessUserId,
        settleType,
        enableRewardCombo,
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      if (timeSlot && timeSlot.length > 0) {
        params.leftCreateDate = timeSlot[0];
        params.rightCreateDate = timeSlot[1];
      }
      exportAPI(params);
    },

    // 删除
    handleDel({ id }) {
      this.$confirm("此操作将永久删除该门店, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteStoreAPI(id).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 启用/禁用
    changeStatus(row) {
      let { id, status } = row;
      let data = { id, status };
      let statusDesc = status ? "启用" : "禁用";

      this.$confirm(`此操作将${statusDesc}该门店, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          row.status = status;
          changeStatusAPI(data).then(() => {
            this.getList();
            this.$message.success("操作成功");
          });
        })
        .catch(() => {
          row.status = !status;
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    changeEnableLogin(row) {
      let { id, enableLogin } = row;
      let data = { id, enableLogin };
      let statusDesc = enableLogin ? "启用" : "禁用";

      this.$confirm(`此操作将${statusDesc}该门店登录, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          row.enableLogin = enableLogin;
          changeEnableLoginAPI(data).then(() => {
            this.getList();
            this.$message.success("操作成功");
          });
        })
        .catch(() => {
          row.enableLogin = !enableLogin;
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },

    async showMaterialImage(row) {
      this.materialUrl = "";
      const { storeName, id } = row;
      const res = await getStoreMaterialAPI(id);
      this.storeName = storeName;
      this.$nextTick(function () {
        this.materialUrl = res.materialImageUrl;
        this.dialogVisibleMaterial = true;
      });
    },

    downloadMaterial() {
      downloadFile(this.materialUrl, this.storeName);
    },

    async showAlipayMaterialImage(row) {
      this.alipayMaterialUrl = "";
      const { storeName, id } = row;
      const res = await getStoreAlipayMaterialAPI(id);
      this.storeName = storeName;
      this.$nextTick(function () {
        this.alipayMaterialUrl = res.alipayMaterialImageUrl;
        this.dialogVisibleAlipayMaterial = true;
      });
    },

    downloadAlipayMaterialImage() {
      downloadFile(this.alipayMaterialUrl, this.storeName);
    },

    copyLink(url) {
      this.$copyText(url).then(
        () => {
          this.$message.success("复制成功");
        },
        () => {
          this.$message.error("复制失败");
        },
      );
    },

    // 关闭弹框
    closeDialogFun(flag) {
      this.showAddOrEdit = false;
      if (flag) {
        this.getList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .header-stats {
    display: flex;
    gap: 24px;
    
    .stat-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      padding: 4px 14px;
      background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
      border-radius: 10px;
      border: 1px solid rgba(64, 158, 255, 0.15);
      
      .stat-label {
        font-size: 12px;
        color: #909399;
        margin-right: 8px;
      }
      
      .stat-value {
        font-size: 16px;
        font-weight: 700;
        color: #409EFF;
        line-height: 1;
      }
    }
  }
}

// 卡片标题样式
.card-header-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f2f5;
  
  i {
    font-size: 18px;
    color: #409EFF;
  }
  
  .header-actions {
    display: flex;
    gap: 12px;
    margin-left: auto;
    
    .add-btn {
      border-radius: 10px;
      padding: 9px 20px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      
      &:hover {
        transform: translateY(-2px);
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
      }
    }
    
    .export-btn {
      border-radius: 10px;
      padding: 9px 20px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #67c23a 0%, #5daf34 100%);
      border: none;
      box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      
      &:hover {
        transform: translateY(-2px);
        background: linear-gradient(135deg, #5daf34 0%, #529b2e 100%);
        box-shadow: 0 4px 12px rgba(103, 194, 58, 0.4);
      }
    }
  }
}

// 搜索卡片样式
.search-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px 28px;
  }

  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 15px;
        margin-bottom: 10px;
        
        .el-form-item__label {
          color: #303133;
          font-weight: 600;
          letter-spacing: 0.3px;
          font-size: 14px;
          position: relative;
          
          &::after {
            content: ':';
            margin-left: 2px;
            color: #909399;
          }
        }
        
        .el-input,
        .el-select {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          
          .el-input__inner {
            border-radius: 10px;
            height: 38px;
            line-height: 38px;
            border: 1.5px solid #E4E7ED;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: #fafbfc;
            font-size: 13px;

            &:hover {
              border-color: #C0C4CC;
              background: #ffffff;
            }
          }
          
          &.is-active .el-input__inner,
          .el-input__inner:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
            background: #ffffff;
          }
        }
        
        .el-date-editor {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          
          .el-range-separator {
            padding: 0 10px;
            color: #606266;
            font-weight: 500;
          }
          
          .el-range-input {
            width: 35%;
            font-size: 13px;
          }
          
          .el-input__inner {
            border-radius: 10px;
            height: 38px;
            border: 1.5px solid #E4E7ED;
            background: #fafbfc;
          }
          
          &:hover .el-input__inner {
            border-color: #C0C4CC;
            background: #ffffff;
          }

          &.is-active,
          &:focus-within {
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
            border-radius: 10px;
            
            .el-input__inner {
              background: #ffffff;
            }
          }
        }
      }
      
      .search-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
          box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
      }

      .reset-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
        border: none;
        box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #909399 0%, #82848a 100%);
          box-shadow: 0 6px 16px rgba(144, 147, 153, 0.35);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
        }
      }
    }
  }
}

// 表格卡片样式
.table-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }

  ::v-deep .tp-table {
    .el-table {
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #EBEEF5;
      background: #ffffff;

      th {
        background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
        color: #303133;
        font-weight: 700;
        padding: 18px 0;
        border-bottom: 2px solid #E4E7ED;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        font-size: 12px;
        
        &:first-child {
          padding-left: 20px;
        }
      }

      tbody {
        tr {
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          border-bottom: 1px solid #F0F2F5;

          &:hover > td {
            background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
          }
          
          &:last-child {
            border-bottom: none;
          }

          td {
            padding: 18px 0;
            border-bottom: 1px solid #F5F7FA;
            
            &:first-child {
              padding-left: 20px;
            }
            
            .store-name-cell {
              display: flex;
              flex-direction: column;
              gap: 8px;
              
              .store-name {
                color: #303133;
                font-weight: 600;
                font-size: 14px;
              }
              
              .store-tags {
                display: flex;
                flex-wrap: wrap;
                gap: 6px;
                
                .store-tag {
                  margin: 0;
                }
              }
            }
            
            .table-cell-text {
              margin: 0;
              color: #606266;
              font-size: 13px;
              line-height: 1.8;
              font-weight: 400;
            }
            
            .amount-value {
              color: #303133;
              font-weight: 600;
              font-size: 14px;
            }
            
            .action-links {
              display: flex;
              flex-wrap: wrap;
              gap: 8px;
              
              .action-link {
                font-weight: 500;
                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                
                &:hover:not(.is-disabled) {
                  transform: translateY(-1px);
                  color: #66b1ff;
                }
                
                &.is-disabled {
                  opacity: 0.5;
                  cursor: not-allowed;
                }
              }
            }
          }
        }
      }
    }
    
    .el-table__fixed-right {
      height: 100% !important;
    }

    .pagination {
      margin-top: 24px;
      padding: 20px 0 0;
      border-top: 2px solid #F0F2F5;
      
      ::v-deep .el-pagination {
        .el-pagination__total {
          color: #606266;
          font-weight: 500;
        }
        
        .btn-prev,
        .btn-next {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            background: #F5F7FA;
            color: #409EFF;
          }
        }
        
        .el-pager li {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            color: #409EFF;
            background: #F5F7FA;
          }
          
          &.active {
            background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
            color: #ffffff;
            font-weight: 600;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
          }
        }
        
        .el-select .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
        }
        
        .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
          
          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
          }
        }
      }
    }
  }
}

// switch按钮样式
::v-deep .switch {
  .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  .el-switch__label--right {
    z-index: 1;
  }

  .el-switch__label--right span {
    margin-left: 5px;
    margin-right: 10px;
  }

  .el-switch__label--left {
    z-index: 1;
  }

  .el-switch__label--left span {
    margin-left: 20px;
  }

  .el-switch__label.is-active {
    display: block;
  }

  .el-switch__core,
  .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}

// 物料对话框样式
::v-deep .material-dialog {
  .el-dialog {
    border-radius: 12px;
    
    .el-dialog__header {
      padding: 20px 24px;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-bottom: 2px solid #f0f2f5;
      
      .el-dialog__title {
        font-size: 18px;
        font-weight: 700;
        color: #1a1e25;
      }
    }
    
    .el-dialog__body {
      padding: 24px;
      
      .dialog-content {
        .section-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          margin-bottom: 20px;
          padding-bottom: 12px;
          border-bottom: 2px solid #f0f2f5;
          
          i {
            font-size: 18px;
            color: #409EFF;
          }
        }
        
        .code-img {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          gap: 16px;
          padding: 20px;
          background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
          border-radius: 10px;
          border: 1px solid #e4e7ed;
          
          .material-image {
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
            
            &:hover {
              transform: scale(1.02);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }
          }
          
          .download-btn {
            border-radius: 8px;
            padding: 10px 24px;
            font-weight: 600;
            background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
            border: none;
            box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
            transition: all 0.3s ease;
            
            &:hover {
              background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
              box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
              transform: translateY(-1px);
            }
          }
        }
      }
    }
  }
}

// 详情抽屉样式
::v-deep .store-detail-drawer {
  .el-drawer__header {
    padding: 20px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-bottom: 2px solid #f0f2f5;
    margin-bottom: 0;
    
    .el-drawer__title {
      font-size: 18px;
      font-weight: 700;
      color: #1a1e25;
    }
  }
  
  .el-drawer__body {
    padding: 0;
  }
}

.store-detail {
  padding: 24px;
  
  .detail-descriptions {
    margin-bottom: 24px;
    
    ::v-deep .el-descriptions__header {
      margin-bottom: 16px;
    }
    
    ::v-deep .el-descriptions__label {
      font-weight: 600;
      color: #606266;
    }
    
    ::v-deep .el-descriptions__content {
      color: #303133;
    }
  }
  
  .detail-tabs {
    margin-top: 24px;
    
    ::v-deep .el-tabs__header {
      margin-bottom: 20px;
      
      .el-tabs__item {
        font-size: 15px;
        font-weight: 500;
        color: #606266;
        transition: all 0.3s ease;
        
        &.is-active {
          color: #409EFF;
          font-weight: 600;
        }
      }
      
      .el-tabs__active-bar {
        background-color: #409EFF;
      }
    }
    
    .image-container {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      
      .detail-image {
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
        cursor: pointer;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .search-card .header-search .el-form ::v-deep {
    .el-form-item {
      margin-right: 12px;
    }
  }
  
  .page-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    
    .header-stats {
      width: 100%;
      justify-content: flex-start;
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .search-card,
  .table-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
  
  .card-header-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    
    .header-actions {
      width: 100%;
      flex-wrap: wrap;
    }
  }
}
</style>
